import { render, staticRenderFns } from "./PixelTable.vue?vue&type=template&id=3d6ce67a"
import script from "./PixelTable.vue?vue&type=script&lang=js"
export * from "./PixelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports